import React from "react";
import commonStyles from "../../Shared/commonStyles.module.css";
import { Link } from "react-router-dom";
import styles from "./PartnerCard.module.css";

function PartnerCard({ name, logo, detailsLIst, website, linkText }) {
  return (
    <div className={`${commonStyles.card} ${styles.PartnerCard}`}>
      <h3 className={styles.cardHeader}>{name}</h3>

      <div className={styles.cardImageContainer}>
        <img src={logo} alt={`${name} logo`} className={styles.cardImage} />
      </div>
      <ul className={styles.cardList}>
        {detailsLIst.map((detail, index) => (
          <li key={index} className={styles.cardListItem}>
            {detail}
          </li>
        ))}
      </ul>
      <Link
        to={website}
        target="_blank"
        rel="noopener noreferrer"
        className={`${commonStyles.btn} ${commonStyles.btnSecondary} ${styles.cardButton}`}
      >
        {linkText || "Visit Website"}
      </Link>
    </div>
  );
}

export default PartnerCard;
